import { Switch } from "@/components/Base/Switch";
import { cn } from "@/lib/utils";
import { useStore } from "@/stores/useStore";

export interface ContainerHeaderSizeToggleProps {
  className?: string;
}

const SWITCH_ID = "dashboard-small-container-titles";

/**
 * Shrinks every container title on the board (see Container.Header). The
 * preference is per-browser, not per-shop — it rides along with card size as a
 * local display setting.
 */
export const ContainerHeaderSizeToggle = ({
  className,
}: ContainerHeaderSizeToggleProps) => {
  const compact = useStore((s) => s.dashboardCompactContainerHeaders);
  const setCompact = useStore((s) => s.setDashboardCompactContainerHeaders);

  return (
    <label
      htmlFor={SWITCH_ID}
      className={cn(
        "flex h-9 cursor-pointer items-center gap-2 px-1",
        className
      )}
    >
      <span className="whitespace-nowrap text-xs font-semibold text-slate-500">
        Small titles
      </span>
      <Switch id={SWITCH_ID} checked={compact} onCheckedChange={setCompact} />
    </label>
  );
};
